
declare global {
    interface Window { COMMERCE_VERSION: any; }
}

export const version = {
  version: '0.0.0',
  buildTimestamp: '1759857774597',
  buildGitRevision: 'a8c7f7f75f90cbaaa69e3a7f9623708c47e060ae'
};

window.COMMERCE_VERSION = version;

